import ReportContext from '../ReportContext';

export default {
    render: function(def, ctx, callback) {
        async function worker() {
            //Check to see if this sub report already exists on this report context...EK
            let subCtx = ctx.subContexts.find(c => c.mvc.drivingView.UID === def.View.UID);

            if (subCtx == null){
                // We haven't loaded this context yet, we need to load or find this view if it is already open...EK
                let mvc = app.dv.cache.mvcs.getVal(def.View);

                if (mvc == null) {      // This view has not been loaded.  Load it and then create the context, otherwise just create the new context against the open view...EK
                    mvc = await new Promise((resolve) => {
                        app.dv.mvc.loadMVC(def.View, false, null, (loadedMvc) => {
                            resolve(loadedMvc);
                            loadedMvc.loadedForReport = true;
                        });
                    });
                }

                subCtx = new ReportContext(mvc, ctx);
            }
            else {
                // We have a context that is already loaded, we need to make sure the datacontext of the report context is correct...EK
                subCtx.prepareDataContext();
            }

            // Now that we have a subCtx, make sure that it's pointer matches the parent so it can take over rendering in the correct spot...EK
            subCtx.detailBounds.left += def.Left;       // Override the left print boundaries based on the location of this control...EK
            subCtx.printBounds.left += def.Left;
            ctx.rootContext.ptr.top += def.runTime.top;

            await subCtx.onReportStart();               // Allow the on report start hook to handle before we render this sub-report...EK

            _render();      // Kick off the render process for this sub-context...EK

            // This function is recursively called when multiple detail pages are needed to render this sub-context...EK
            function _render() {
                subCtx.renderPageHeader(() => {
                    subCtx.renderDetail(() => {
                        if (subCtx.newPageNeeded == false){
                            subCtx.rootContext.ptr.top -= def.runTime.top;  // Reset the root context's ptr before we hand it back to the calling context...EK
                            subCtx.detailBounds.left -= def.Left;           // Reset the left bounds (so it doesn't move to the right each cycle) ... EK
                            subCtx.printBounds.left -= def.Left;
                            subCtx.dataContextIndex = 0;            // Reset the context pointer so we start at the first record if we do this sub again...EK

                            callback()
                        }
                        else {
                            subCtx.rootContext.renderPageFooter(() => {
                                //We need a new page.. use a set timeout so we don't have a large call stack (and possible stack overflow)...EK
                                setTimeout(() => {
                                    subCtx.newPageNeeded = false;
                                    subCtx.makeNewPage(false, () => {
                                        subCtx.rootContext.ptr.top = 0;     //Be sure the rootContext ptr is set to 0 to render the page header...EK
                                        subCtx.rootContext.renderAllPageHeaders().then(() => {
                                            _render();
                                        });
                                    });
                                }, 0);
                            });
                        }
                    });
                });
            }
        }

        worker();
    },
    preRender: function(def, ctx, callback) {
        if (def.runTime == null){
            def.runTime = {
                top: def.Top
            }
        }
        else {
            def.runTime.top = def.Top;      // Reset the top in case of growth layout changes...EK
        }
        // As of now, there is no pre-render for this report control (it will execute sub-pre renders as it renders its own controls) ... EK
        callback();
    }
};
